var parent = require('../../stable/object');
// TODO: Remove from `core-js@4`
require('../../modules/esnext.object.has-own');
require('../../modules/esnext.object.iterate-entries');
require('../../modules/esnext.object.iterate-keys');
require('../../modules/esnext.object.iterate-values');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/features/object/index.js
// module id = 271
// module chunks = 0